import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL, USER_URL } from '../../constant/api';
import axios from 'axios';
import DeleteModal from '../../components/DeleteModal/DeleteModal';

function AdminBrand() {
  const [products, setProducts] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Dummy data for when no products are fetched
  const dummyData = [
    {
      id: 1,
      brandname: 'Brand One',
      status: 'Active'
    },
    {
      id: 2,
      brandname: 'Brand Two',
      status: 'Inactive'
    },
    {
      id: 3,
      brandname: 'Brand Three',
      status: 'Active'
    }
  ];

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/products/admin/brands/`);
        if (response.data?.data) {
          setProducts(response.data?.data);
        } else {
          // If no products are returned, use dummy data
          setProducts(dummyData);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
        // In case of error, fallback to dummy data
        setProducts(dummyData);
      }
    };
    fetchProducts();
  }, []);

  console.log(products);

  // Handle delete confirmation
  const handleDelete = async () => {
    if (selectedProduct) {
      try {
        await USER_URL.delete(`/products/admin/brands/${selectedProduct.id}/`);
        setProducts(products.filter((p) => p.id !== selectedProduct.id));
        setShowConfirm(false);
        setSelectedProduct(null);
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
      }
    }
  };

  return (
    <div className=" ">
      <h1 className='text-2xl font-medium text-green-600 '>Admin Brand</h1>
      {/* Header with Add New Banner Button */}
      <div className="flex justify-end items-center m-5">
        <Link
          to="/admin/add/brand"
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg shadow"
        >
          + Add New Brand
        </Link>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto mt-4 ">
        <table className="w-full text-center ">
          <thead>
            <tr>
              <th className="py-2 text-green-500 text-md font-bold">Item No</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Brand Name</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Status</th>
            </tr>
          </thead>

          <tbody>
            {products.length > 0 ? (
              products.map((product, index) => (
                <tr key={product.id}>
                  {/* Item Number (Index + 1) */}
                  <td className="py-3 px-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {index + 1}
                    </div>
                  </td>

                  {/* Brand Name */}
                  <td className="py-3 px-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.brandname || "Name"}
                    </div>
                  </td>

                  {/* Status */}
                  <td className="py-3 px-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.status || "Pen"}
                    </div>
                  </td>

                  {/* Action Buttons */}
                  <td className="py-3 px-4 text-sm">
                    <div className="flex gap-5">
                      {/* Edit Button */}
                      <Link
                        to={`/admin/edit/brand/${product.id}`}
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 hover:border-blue-700 transition text-center"
                      >
                        Edit
                      </Link>

                      {/* Delete Button */}
                      <button
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-red-600 hover:text-white border border-red-600 rounded-lg shadow-md hover:bg-red-700 hover:border-red-700 transition text-center"
                        onClick={() => {
                          setSelectedProduct(product);
                          setShowConfirm(true);
                        }}
                      >
                        Delete
                      </button>

                      {/* View Button */}
                      <Link
                        to={`/admin/create/brand/view/${product.id}`}
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-green-600 hover:text-white border border-green-600 rounded-lg shadow-md hover:bg-green-700 hover:border-green-700 transition text-center"
                      >
                        View
                      </Link>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-600">
                  No banners found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="brand"
          title={selectedProduct?.brandname}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default AdminBrand;
